import moment from 'moment';

class DateTimeService 
{
    constructor() {        
    }
  
    formatDate(dateTimeValue) { 
        let dateTime = moment(dateTimeValue);
        return dateTime.isValid() ? dateTime.format("DD/MM/YYYY") : "";
    }
    
    isValidDate(dateTimeValue) {
        let dateTime = moment(dateTimeValue,'DD/MM/YYYY', true);
        return dateTime.isValid(dateTimeValue);
    }

    convertToDateString(dateTimeValue) {
        if (dateTimeValue) {
            return moment(dateTimeValue, 'DD/MM/YYYY', true).format();
        } else {
            return null;
        }    
    }

    parseDateToString(dateTimeValue) { 
        let dateTime = moment(dateTimeValue);
        return dateTime.isValid() ? dateTime.format('DD/MM/YYYY') : null;       
    }
}

export default DateTimeService;


// WEBPACK FOOTER //
// ./app/services/date-time.service.js